declare var $;

import { SimplePaymentView } from '../tv_payments/payments';

/**
 * Class to fetch the payment section's HTML via AJAX and handle the user interactions with the results.
 */
export class PaymentSection {
    /**
     * @var {string} sales_id of the order.
     * @var {SimplePaymentView} payment_view form to allow user to pay for the order.
     */
    sales_id: string;
    payment_view: SimplePaymentView;

    /**
     * Fetch the HTML for the section on load, then when complete bind the controls.
     *
     * @param {string} sales_id of the order.
     * @returns {PaymentSection} with request pending.
     */
    constructor(sales_id:string) {
        this.sales_id = sales_id;
        this.payment_view = null;
        this.async_init();
    }

    /**
     * Fetches the DOM content for the payment section.
     *
     * @returns {void}
     */
    async_init() : void {
        $.ceAjax('request', 'index.php?dispatch=tv_customer_orders.payment_status', {
            method: 'POST',
            cache: false,
            hidden: true,
            result_ids: 'js-order-details-payment-section,js-submit-payment-form',
            callback: this.async_init_callback.bind(this),
            data: { sales_id: this.sales_id }
        });
    }

    /**
     * When the DOM content is returned, bind the paynow button and create the payment form if needed.
     *
     * @returns {void}
     */
    async_init_callback() : void {
        if (document.getElementById('opener_pay_now-' + this.sales_id)) {
            const accepted_payment_types = {
                'cc_saved': true,
                'cc_new': true,
                'net_terms': true,
                'pay_later': false,
                'paypal': true
            };

            this.payment_view = new SimplePaymentView(
                accepted_payment_types,
                'js-pay-now-popup',
                false,
                this.async_init.bind(this),
                true
            );
        }
    }
}
